export const ACTIVE = 'msg_codes_agreementStatus_active';
export const INACTIVE = 'msg_codes_agreementStatus_inactive';
